import { updateWaiver } from "../../api/historyService";

export const useUpdateWaiver = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateWaiver(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update waiver:", error);
        throw error;
    }
  };

  return { update };
};